module.exports = __webpack_public_path__ + "static/media/status.a0534484.svg";